import type { FormSchemaEntry } from "@gik/ui-legacy/Form";
import type { RefObject } from "react";
import { CityField } from "../fields/CityField";
import { CompanyNameField } from "../fields/CompanyNameField";
import { CountryField } from "../fields/CountryField";
import { FirstNameField } from "../fields/FirstNameField";
import { LastNameField } from "../fields/LastNameField";
import { PhoneField } from "../fields/PhoneField";
import { StateField } from "../fields/StateField";
import {
	StreetAddress1Field,
	StreetAddress2Field,
} from "../fields/StreetAddressField";
import { ZipCodeField } from "../fields/ZipCodeField";

export const BillingAddressFormSchema: (
	ref?: RefObject<HTMLElement>,
) => FormSchemaEntry[] = (ref) => [
	FirstNameField(),
	LastNameField(),
	CompanyNameField(),
	CountryField(),
	StreetAddress1Field(),
	StreetAddress2Field(),
	CityField(),
	StateField({ scrollParent: ref }),
	ZipCodeField(),
	PhoneField(),
];
